import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import zh from './zh.json';

export type Locale = 'en' | 'fr' | 'it' | 'zh';

export const locales: Record<Locale, { name: string }> = {
  en: { name: 'English' },
  fr: { name: 'Français' },
  it: { name: 'Italiano' },
  zh: { name: '中文' },
};

export const translations = {
  en,
  fr,
  it,
  zh,
};

export function getTranslation(locale: Locale) {
  return translations[locale] || translations.en;
}

export function getNameByLocale(locale: Locale) {
  return locales[locale]?.name || locales.en.name;
}

export const defaultLocale: Locale = 'en';
